/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'User',
        isRequired: true,
      },
    },
  }],
} as const;
